import React from 'react';

const AddressState = ({code, name}) => {
    return (
        <div className={`address-state address-state__${code}`}>
            {name}
        </div>
    );
};

export default AddressState;


// WEBPACK FOOTER //
// ./App/components/addressState.jsx